var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { MultipassExternalService } from '@square/dashboard-protos/models/squareup/multipass/external';
import Service, { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import rpc, { apiHostUrl } from '@banking/api/utils/rpc';
let MultipassExternalApi = (_dec = computed('capitalEngineContext.headers'), _class = class MultipassExternalApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
  }
  get client() {
    const headers = new Map(Object.entries(this.capitalEngineContext.headers));
    headers.delete('X-MULTIPASS-SESSION-SCOPE');
    return MultipassExternalService.create(rpc(apiHostUrl, headers, false));
  }
  enrollTwoFactor(enrollTwoFactorRequest) {
    return this.client.enrollTwoFactor(enrollTwoFactorRequest);
  }
  sendVerificationCode(verificationCodeRequest) {
    return this.client.sendVerificationCode(verificationCodeRequest);
  }
  upgradeSessionTwoFactorRequest(twoFactorDetails) {
    return this.client.upgradeSessionTwoFactor({
      twoFactorDetails
    });
  }
  listTwoFactor() {
    return this.client.listTwoFactor({});
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _class);
export { MultipassExternalApi as default };